import { render, staticRenderFns } from "./BaseSuccessDialog.vue?vue&type=template&id=c0dc5780"
import script from "./BaseSuccessDialog.vue?vue&type=script&lang=js"
export * from "./BaseSuccessDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports